export default "__VITE_ASSET__a9694444__"